export enum ProductTypeEnum {
  MIRRORLESS = "mirrorless",
  REFLEX = "reflex",
  COMPATTA = "compatta",
  BRIDGE = "bridge",
  OBIETTIVO = "obiettivo"
}
